<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <FiltroNotasFiscaisImportadas/>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import FiltroNotasFiscaisImportadas from '@/router/views/admin/nfse/components/filtro-nfse-importadas.vue'
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Notas Fiscais Importadas do ADN",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    FiltroNotasFiscaisImportadas
  },
  data() {
    return {
      title: "Notas Fiscais Importadas do ADN",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Notas Fiscais Importadas do ADN',
          active: true,
        },
      ],
    };
  }
};
</script>
